// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2QkTX","choiceBoxes":"toolbarselects_choiceBoxes__2-plP","simpleField":"toolbarselects_simpleField__2Ii1R"};